<template>
    <div class="bucket-wrapper">
        <div class="content">
            <div
                class="header"
                :class="{ _tablet: tabletAndLess && !phoneAndLess }"
                v-if="!phoneAndLess"
                @mouseleave="showToolTip = false"
            >
                <div class="title">Необходимо запланировать</div>
                <component
                    v-if="getHasGoals"
                    :is="getHasMultipleGoals ? 'a' : 'router-link'"
                    :to="getGoals[0] ? getGoals[0].publicationLink : ''"
                    class="add-education"
                    @mouseenter="showToolTip = true"
                >
                    Добавить обучение
                </component>
                <GoalsPopup
                    v-if="getHasMultipleGoals"
                    class="goals-dialog desktop-dialog"
                    :class="{ 'desktop-active': showToolTip }"
                />
            </div>
            <div
                class="items"
                ref='bucket'
                :class="{
                    stub: 0 === getBucketPrograms.length,
                    almostStub: 0 < getBucketPrograms.length && getBucketPrograms.length < 3,
                    _phone: phoneAndLess,
                }"
            >
                <EducationItem
                    v-for="(item, index) in getBucketPrograms"
                    :key="index"
                    :education="item"
                    :scrolledEl="bucketVal"
                />
            </div>
            <component
                :is="getHasMultipleGoals ? 'a' : 'router-link'"
                v-if="phoneAndLess"
                :to="getGoals[0] ? getGoals[0].publicationLink : ''"
                class="add-education _mobile"
                @click="goalsDialog = true"
            >Добавить дату старта
                <div
                    class="goals-overlay"
                    v-if="showGoalsDialog"
                    @click.stop="goalsDialog = false"
                >
                    <GoalsPopup
                        @click.stop
                        v-if="showGoalsDialog"
                        class="goals-dialog"
                        @close="goalsDialog = false"
                    />
                </div>
            </component>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

const trackGetters = [
    'getBucketPrograms',
    'getHasMultipleGoals',
    'getHasGoals',
    'getGoals',
];

import EducationItem from './components/EducationItem';
import GoalsPopup from '../components/GoalsPopup';

export default {
    data: () => ({
        goalsDialog: false,
        showToolTip: false,
        bucketVal: null,
    }),
    components: {
        GoalsPopup,
        EducationItem,
    },
    name: 'Bucket',
    computed: {
        ...mapGetters('accountTrack', trackGetters),
        ...mapGetters(['width']),
        desktopAndMore() {
            return this.width > 768;
        },
        tabletAndLess() {
            return this.width <= 768;
        },
        phoneAndLess() {
            return this.width <= 415;
        },
        showGoalsDialog() {
            return this.goalsDialog && this.tabletAndLess && this.getHasMultipleGoals;
        },
    },
    updated() {
        this.bucketVal = this.$refs.bucket;
    },
    mounted() {
        this.bucketVal = this.$refs.bucket;
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.bucket-wrapper {
    background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 4px;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    border: 1px solid #D2D5D9;

    @include on-sm {
        min-height: 82vh;
    }

    @include on-xs {
        border: none;
        box-shadow: 0 2px 8px rgba(155, 161, 166, 0.23626);
    }

    .content {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;

        .stub {
            width: 100%;
            height: 100%;
        }

        .items {
            padding: 24px;
            @include custom-scroll-bar;
            overflow-y: scroll;

            & > * {
                margin-bottom: 16px;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }

        .stub {
            background-image: url("~@/assets/images/account-track/empty-bucket.svg");
            background-repeat: no-repeat;
            background-position: center 16px;
            background-size: 60%;
            &._phone {
                background-image: url("~@/assets/images/account-track/empty-bucket-phone.svg");
                background-position: center 100%;
            }
        }

        .almostStub {
            height: 100%;
            background-image: url("~@/assets/images/account-track/almost-empty-bucket.svg");
            background-repeat: no-repeat;
            background-position: center 316px;
            background-size: 60%;

            @include on-md {
                height: auto;
            }
        }
    }

    .header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #D2D5D9;
        padding: 24px;
        position: relative;

        &._tablet {
            padding-bottom: 16px;
        }

        .title {
            font-style: normal;
            font-weight: 600;
            font-size: 22px;
            line-height: 30px;
            color: #2A2626;
        }

        .goals-dialog {
            top: calc(50% + 16px);
            left: 24px;
            right: 24px;
            max-width: unset;

            @include on-md {
                left: auto;
                max-width: 549px;
            }

            @include on-sm {
                left: 24px;
                max-width: unset;
            }
        }
    }
}

.add-education {
    box-sizing: border-box;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #4663AB;
    cursor: pointer;
    text-align: right;
    min-width: 190px;
    user-select: none;

    &._mobile {
      background-color: #fff;
      margin-top: 24px;
      padding: 10px 0;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      border-top: 2px solid #F3F3F3;
    }
}

.header-action-container{
    position: relative;
}

.desktop-dialog {
    &.goals-dialog {
        display: none;

        &.desktop-active {
            display: block;
        }
    }
}

.goals-overlay {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#000, 0.4);
}
</style>
